import { render, staticRenderFns } from "./Vacaciones.vue?vue&type=template&id=aa59c98c"
import script from "./Vacaciones.vue?vue&type=script&lang=js"
export * from "./Vacaciones.vue?vue&type=script&lang=js"
import style0 from "./Vacaciones.vue?vue&type=style&index=0&id=aa59c98c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports